import React from 'react';
import { motion } from 'framer-motion';

const Procedimentos = () => {
  const procedimentos = [
    { 
      title: "Inserção de DIU", 
      description: "Método contraceptivo moderno, seguro e eficaz. A escolha e a colocação são feitas de forma personalizada, respeitando o seu corpo e garantindo o seu conforto durante todo o procedimento.", 
      icon: "💍" 
    },
    { 
      title: "Colposcopia (Pesquisa de HPV)", 
      description: "Exame essencial para avaliação detalhada do colo do útero, permitindo identificar alterações causadas pelo HPV de forma precoce, aumentando as chances de prevenção e tratamento eficaz.", 
      icon: "🔬" 
    },
    { 
      title: "Cauterização (CAF)", 
      description: "Procedimento indicado para tratar alterações no colo do útero, geralmente relacionadas ao HPV. Realizado com segurança e precisão, ajudando na prevenção de complicações futuras.", 
      icon: "⚡" 
    },
    { 
      title: "Implante Hormonal", 
      description: "Tecnologia moderna que auxilia no equilíbrio hormonal, podendo contribuir para contracepção, melhora da disposição, libido, controle de sintomas da menopausa e qualidade de vida.", 
      icon: "💊" 
    }
  ];

  const handleAgendar = () => {
    window.open("https://wa.me/5563991352552?text=Olá%2C%20gostaria%20de%20agendar%20uma%20consulta.", "_blank");
  };

  return (
    <section id="procedimentos" className="py-20 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Título da seção */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-textDark mb-4">
            Procedimentos
          </h2>
          <p className="text-textLight max-w-2xl mx-auto">
            Tecnologia e segurança para o seu bem-estar
          </p>
          <div className="w-20 h-1 bg-primary mx-auto mt-4 rounded-full"></div>
        </motion.div>

        {/* Grid de procedimentos */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {procedimentos.map((proc, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="bg-secondary/10 rounded-2xl p-6 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <h3 className="text-xl font-serif font-semibold text-primary mb-3">
                {proc.title}
              </h3>
              <p className="text-textLight leading-relaxed text-sm">
                {proc.description}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Botão centralizado */}
        <div className="text-center mt-12">
          <button
            onClick={handleAgendar}
            className="bg-primary text-white px-8 py-3 rounded-full font-semibold hover:bg-primaryDark transition-all duration-300 hover:scale-105"
          >
            Agendar consulta
          </button>
        </div>
      </div>
    </section>
  );
};

export default Procedimentos;